import { Quote } from "lucide-react";
import { Reveal, Eyebrow, DoctorImage, GoldDivider } from "./Reveal";

const FOCUS = ["Autism", "ADHD", "Speech Delay", "Developmental Concerns"];

export default function Doctor({ onRequest }) {
  return (
    <section id="doctor" data-testid="doctor-section" className="bg-[#F4EFE6] border-y border-[#E5D3AD]/40 py-16 lg:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-3 rounded-[2.2rem] border border-[#C5A059]/40 rotate-2" />
            <DoctorImage className="aspect-[4/5] w-full shadow-[0_24px_60px_rgb(27,59,43,0.16)]" rounded="rounded-[2rem]" />
            <div className="absolute -bottom-6 -left-3 sm:-left-8 w-32 sm:w-40 rotate-[-3deg] bg-[#FAF7F2] p-2 pb-3 rounded-xl shadow-[0_16px_40px_rgb(27,59,43,0.25)] border border-[#E5D3AD]">
              <img
                src="/award.jpg"
                alt="Dr. Santhisree Bheesetti receiving the Times Health Excellence Award"
                loading="lazy"
                className="w-full h-24 sm:h-28 object-cover rounded-lg"
                style={{ objectPosition: "center 30%" }}
              />
              <p className="mt-2 text-[9px] sm:text-[10px] font-semibold tracking-[0.14em] uppercase text-[#B85D43] text-center leading-tight">
                Award-Recognized Care
              </p>
            </div>
            <div className="absolute -bottom-5 -right-3 sm:-right-6 bg-[#1B3B2B] text-[#FAF7F2] rounded-2xl px-5 py-4 shadow-xl">
              <p className="font-serif text-2xl text-[#C5A059]">15+</p>
              <p className="text-[10px] tracking-[0.2em] uppercase">Years of Clinical Experience</p>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>Chapter 06 · Your Physician</Eyebrow>
            <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight">
              Meet Dr. Santhisree Bheesetti
            </h2>
            <p className="mt-4 text-base font-semibold text-[#1B3B2B]">Dr. Santhisree Bheesetti, B.A.M.S</p>
            <p className="text-sm text-[#5C6E62]">Founder &amp; Chief Physician · Sree Prathama Ayurvedam</p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-8 relative bg-[#FAF7F2] border border-[#E5D3AD]/50 rounded-3xl p-8">
              <Quote className="absolute -top-4 left-8 w-8 h-8 text-[#C5A059] fill-[#C5A059]" />
              <p className="font-serif italic text-xl sm:text-2xl text-[#1B3B2B] leading-relaxed">
                "When we understand the child, we can support their unique path."
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.18}>
            <p className="mt-8 text-sm font-semibold tracking-[0.18em] uppercase text-[#B85D43]">
              Special focus on children with
            </p>
            <div className="mt-4 flex flex-wrap gap-2.5">
              {FOCUS.map((f) => (
                <span
                  key={f}
                  className="bg-[#EAF0EC] text-[#1B3B2B] px-4 py-2 rounded-full text-xs font-semibold tracking-wider border border-[#5B7566]/20"
                >
                  {f}
                </span>
              ))}
            </div>
            <GoldDivider className="!mx-0 mt-10" />
            <button
              data-testid="doctor-section-cta"
              onClick={() => onRequest()}
              className="mt-8 bg-[#1B3B2B] text-[#FAF7F2] font-semibold tracking-wide text-sm px-8 py-4 rounded-full hover:bg-[#132C20] transition-all duration-300 hover:-translate-y-0.5"
            >
              REQUEST YOUR CONSULTATION
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
